export const socketConstants = {
  INIT: 'SOCKET_INIT',
  SUBSCRIBE: 'SOCKET_SUBSCRIBE',
  UNSUBSCRIBE: 'SOCKET_UNSUBSCRIBE',
  CLOSE: 'SOCKET_CLOSE',
  FAILED: 'SOCKET_FAILED',
  RECONNECT: 'SOCKET_RECONNECT',
}
